import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { TextComponent } from '../../atoms/text/text.component';
import { CommonModule } from '@angular/common';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { gsap } from "gsap"; 

@Component({
  selector: 'app-tab-menu-restitucion',
  standalone: true,
  imports: [
    CommonModule,
    TextComponent,
    CommonNgModule
  ],
  templateUrl: './tab-menu-restitucion.component.html',
  styleUrl: './tab-menu-restitucion.component.scss'
})
export class TabMenuRestitucionComponent {
  active:boolean = true;
  @Input() Theme:any;
  @Input() Items:any = [];
  @Output() tabViewSelected: EventEmitter<any>;
  @ViewChildren('bgTab') bgTab!: QueryList<ElementRef>
  @ViewChildren('textTab') textTab!: QueryList<ElementRef>
  selected:any;
  load_Data:boolean = false;
  preventDefaultMotion:boolean = true;
  constructor() {
    this.tabViewSelected = new EventEmitter();
  }
  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  DF_tab(_itemBg:any, _itemText:any, _actions:any){
    this.selected = gsap.timeline({ repeat: 0, yoyo: true, paused: true, onComplete: () => {
      setTimeout(() => {
        this.preventDefaultMotion =  true;
      }, 300);
    }});
    this.selected.fromTo( _itemBg, 0.3, { width:'0', borderRadius:'0'  }, { width:'100%', borderRadius:'50', ease: "power2.out" } );
    this.selected.fromTo( _itemText, 0.3, { opacity:0, y:5 }, { opacity:1, y:0, ease: "power2.out" }, '-=0.25' );
    if(_actions === 'play'){
      this.selected.play();
    }
    if(_actions === 'reverse'){
      this.selected.reverse();
    }
    
  }

  activeTabs(_event:any, _item:any){
    this.preventDefaultMotion =  false;
    this.Items.find((x:any) => {
      x.active = false; // desactivamos
      // luego verificamos el clikeado y activamos
      if (_item.id === x.id) {
        x.active = true;
        this.DF_tab(this.bgTab['_results'][x.id].nativeElement, this.textTab['_results'][x.id].nativeElement, 'play');
      }
    });
    const objectMaped = {
      event: _event,
      item: _item
    }
    this.tabViewSelected.emit(objectMaped);
    
    
  }

  eventTab(event:any, item:any){
    if(!item.active && this.preventDefaultMotion){
      this.activeTabs(event, item);
      event.stopPropagation();
    }
  }
}
